import { useContext } from 'react'

import { DialogsContext } from './dialogs-provider'

const useDialog = () => {
  const context = useContext(DialogsContext)

  if (context === undefined) {
    throw new Error('useDialog must be used within a DialogsProvider')
  }

  return context
}

export default useDialog
